import { useEmailAction } from './useEmailAction';
import { useUserCommunicationsStore } from '../../../store';

export const useReplyUserCommunication = () => {
  const { setReplyLoading } = useUserCommunicationsStore();

  const { handleEmailAction } = useEmailAction(() => ({
    setLoading: setReplyLoading,
    successKey: 'inbox.userCommunication.actions.replySuccess',
    errorKey: 'inbox.userCommunication.actions.replyError',
  }));

  return { handleReplyUserCommunication: handleEmailAction };
};
